import { Actions } from './constants';

/**
 * Action to signal that the user is entering a backstage page
 *
 * @param {object} payload - nextState data
 * @returns {object} - action
 */
export function enterBackstage(payload) {
  return {
    type: Actions.ENTER_BACKSTAGE,
    payload,
  };
}

/**
 * Action to signal that the user is leaving a backstage page
 *
 * @returns {object} - action
 */
export function leaveBackstage() {
  return {
    type: Actions.LEAVE_BACKSTAGE,
  };
}
